import { hbs } from 'ember-cli-htmlbars';
export default hbs("<p class={{join-classes \'display-inline\'}}>{{concat\n    @record.coffeeColor\n    \'±\'\n    @record.coffeeColorDeviation\n  }}</p>")